export const environment = {
    production: true,
    enableDebug: false,
    // BACKEND_URL:'https://arabianbe-dev.ilooopsqhse.com'
    BACKEND_URL: 'https://rbqhsebe.rbdemo.live'
    // BACKEND_URL:'http://localhost:8000',    //LOCAL
  };



// WEBPACK FOOTER //
// /app/src/environments/environment.mssql-dev.ts